.firstColGrow {
    & > div:first-child {
        flex: 2;
    }
}

.lastColGrow {
    & > div:last-child {
        flex: 2;
    }
}

.twoColEven {
    display: grid;
    grid-template-columns: 1fr 1fr;
}
